import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  user: null,
  loader: false,
  modalFolder: false,
  studiesdata: [], // Initialize the studiesdata property as an array
  iconVisible: false,
  FolderGet: "",
  FolderList: [],
  RefreshLoader: false,
  buttonTop: false,
  studyListButton: false,
  allResponse: false,
  fileLength: 0,
  folderSearch: [],
  lastLogin: "",
  notifciationList: [],
  folderName: "",
  isShared: false,
  isUpload: false,
  isOnlyKeyImages: false,
  canShare: false,
  isLocalFS: false,
  localFSPath: "",
};

export const counterSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    addUser: (state, action) => {
      state.user = action.payload;
    },
    logoutUser: (state, action) => {
      return { ...initialState };
    },
    foldersave: (state, action) => {
      state.foldersave = action.payload;
    },
    studiesdata: (state, action) => {
      state.studiesdata = action.payload;
    },
    setLoader: (state, action) => {
      state.loader = action.payload;
    },
    setModalFolder: (state, action) => {
      state.modalFolder = action.payload;
    },
    setIconVisibility: (state, action) => {
      state.iconVisible = action.payload;
    },
    setFolderGet: (state, action) => {
      state.FolderGet = action.payload;
    },
    setFolderList: (state, action) => {
      state.FolderList = action.payload;
    },
    setFolderSearch: (state, action) => {
      state.folderSearch = action.payload;
    },
    setRefreshLoader: (state, action) => {
      state.RefreshLoader = action.payload;
    },
    setbuttonTop: (state, action) => {
      state.buttonTop = action.payload;
    },
    setStudyListButton: (state, action) => {
      state.studyListButton = action.payload;
    },
    setallResponse: (state, action) => {
      state.allResponse = action.payload;
    },
    fileLength: (state, action) => {
      state.fileLength = action.payload;
    },
    setlastLogin: (state, action) => {
      state.lastLogin = action.payload;
    },
    setNotifciationList: (state, action) => {
      state.notifciationList = action.payload;
    },
    setFolderName: (state, action) => {
      state.folderName = action.payload;
    },
    setIsShared: (state, action) => {
      state.isShared = action.payload;
    },
    setIsUpload: (state, action) => {
      state.isUpload = action.payload;
    },
    setIsOnlyKeyImages: (state, action) => {
      state.isOnlyKeyImages = action.payload;
    },
    setIsCanShare: (state, action) => {
      state.canShare = action.payload;
    },
    setIsLocalFs: (state, action) => {
      state.isLocalFS = action.payload;
    },
    setLocalFsPath: (state, action) => {
      state.localFSPath = action.payload;
    }
  },
});

// Action creators are generated for each case reducer function
export const {
  addUser,
  setlastLogin,
  studiesdata,
  logoutUser,
  foldersave,
  setLoader,
  setModalFolder,
  setIconVisibility,
  setFolderGet,
  setFolderList,
  setRefreshLoader,
  setbuttonTop,
  setStudyListButton,
  setallResponse,
  fileLength,
  setFolderSearch,
  setNotifciationList,
  setFolderName,
  setIsShared,
  setIsUpload,
  setIsOnlyKeyImages,
  setIsCanShare,
  setIsLocalFs,
  setLocalFsPath
} = counterSlice.actions;

export default counterSlice.reducer;
